import Link from "next/link";
import Image from "next/image";
import { unstable_ViewTransition as ViewTransition } from "react";
import SVG from "react-inlinesvg";

function MethodCard({ name, url, image, number, shoulder = null, title, description, isCurrent, className }) {
  return (
    <Link className={`method-card ${isCurrent ? "current" : ""} ${className}`} href={url}>
      <div className="inner">
        <div className="method-card-image">
          {/* <Image src={image} alt="" width={458} height={342} /> */}
          <img src={image} alt="" />
        </div>
        <div className="method-card-inner">
          <div className="method-card-header">
            <div className="method-card-number en">{number}</div>
            {shoulder && <div className="method-card-shoulder bold" dangerouslySetInnerHTML={{ __html: shoulder }}></div>}
            <h2 className="method-card-title en" dangerouslySetInnerHTML={{ __html: title }}></h2>
            <p className="method-card-description bold" dangerouslySetInnerHTML={{ __html: description }}></p>
          </div>
          <div className="method-card-arrow pcOnly">
            <i className="icon">
              <SVG src="/assets/img/common/icon/icon-arrow-right.svg" />
            </i>
          </div>
        </div>
      </div>
    </Link>
  );
}

export default function Component({currentNumber=null, className=""}) {
  return (
    <div className="method-cards">
      {[
        {
          name: "method-card-container-1",
          url: "/method/soil-solution/",
          image: "/assets/img/method/soil/kv-pic.jpg",
          number: "01",
          shoulder:"おいしく育つ土づくり",
          title: `Soil Solution`,
          description: `収量もしっかり維持しながら、<br />自然な多様性を持つ健康な土へ。`,
          isCurrent:false,
        },
        {
          name: "method-card-container-2",
          url: "/method/agrilca/",
          image: "/assets/img/method/agrilca/kv-pic.jpg",
          number: "02",
          shoulder:"土壌の価値の可視化",
          title: `Agri LCA+`,
          description: `土の価値を評価し、可視化。食べ手とつくり手、<br />双方にとって本質的な「いい農業」の指標になります。`,
          isCurrent:false
        },
        {
          name: "method-card-container-3",
          url: "/method/next-green-credit/",
          image: "/assets/img/method/credit/kv-pic.jpg",
          number: "03",
          shoulder: `土づくりの好影響の価値化`,
          title: `<span class="en">Next Green Credit</span>`,
          description: `Agri LCA+での評価を基に、<br />日本初の多面的な環境クレジットとして価値に変換。<br />いい土になるほど、新たな収入源に。`,
          isCurrent:false
        },
      ].map((obj, index) => {
        obj.isCurrent = index==currentNumber
        if (obj.isCurrent) {
          return <MethodCard key={index} {...obj} className={className} />;
        } else {
          return (
            <ViewTransition key={index} name={obj.name}>
              <MethodCard {...obj} className={className} />
            </ViewTransition>
          );
        }
      })}
    </div>
  );
}
